module.exports = __webpack_public_path__ + "static/media/beauty_health.0b1f4cf0.jpg";